<template>
  <cf-expandable-section class="cf-card cf-card--clickable">
    <template #title>
      <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-16">
        <button
          v-if="orderDetails.orderType !== 'catering' && selectedLocation.isReadyForOrdering && !menu.unavailablePerSchedule"
          type="button"
          title="Add to Cart"
          class="cf-button cf-button--secondary cf-button--fixed-40 cf-relative-position"
          :class="{'cf-button--loading': reorderingOrderId === order.orderId }"
          @click.stop="reorder(order)"
        >
          <span class="cf-icon cf-icon--brand-primary far fa-plus" />

          <span class="ada-text">
            Reorder
          </span>
        </button>

        <div class="cf-flex cf-flex--column">
          <h4 class="cf-title cf-title--4">
            {{ order.nickname }}
          </h4>

          <p class="cf-subtitle cf-subtitle--2">
            {{ order.orderItemCount }} items
          </p>
        </div>
      </div>
    </template>

    <template #content>
      <div class="cf-flex cf-flex--column cf-flex--gap-16">
        <div class="cf-flex cf-flex--column cf-flex--gap-12">
          <cf-order-item
            v-for="orderItem in order.orderItems"
            :key="orderItem.orderItemId"
            :item="orderItem"
            :order="order"
            :hide-prices="true"
            :is-favoriting-disabled="true"
            is-read-only
            class="cf-list-item-padding-bottom cf-list-item-border-bottom"
          />
        </div>

        <div class="cf-grid cf-grid--2-grid-column-equal">
          <div class="cf-flex cf-flex--row cf-flex--align-center">
            <button
              v-if="orderDetails.orderType !== 'catering' && selectedLocation.isReadyForOrdering && !menu.unavailablePerSchedule"
              class="cf-button cf-button--primary cf-button--smedium"
              :class="{'cf-button--loading': reorderingOrderId === order.orderId }"
              type="button"
              @click="reorder"
            >
              Reorder
            </button>
          </div>

          <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-end cf-flex--grow-1 cf-flex--gap-8">
            <button
              class="cf-button cf-button--tertiary cf-button--xs"
              title="Edit Saved Address"
              type="button"
              @click="editFavoriteOrderClickHandler"
            >
              Edit
            </button>

            <button
              class="cf-button cf-button--tertiary cf-button--fixed-24"
              title="Delete Saved Address"
              type="button"
              @click="confirmDeleteFavoriteOrder"
            >
              <span class="cf-icon far fa-trash-alt" />

              <span class="ada-text">Delete Favorite Order</span>
            </button>
          </div>
        </div>
      </div>
    </template>
  </cf-expandable-section>
</template>


<script>
  import { mapGetters } from 'vuex';

  import errorHandlers from '@/services/error-handlers';

  import CfExpandableSection from '@/view/components/shared/cf-expandable-section/index.vue';

  import CfOrderItem from '@/view/components/globals/cf-order-item/index.vue';


  export default {
    name: 'CfFavoriteOrder',

    components: {
      CfExpandableSection,
      CfOrderItem
    },

    props: {
      order: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        reorderingOrderId: null
      };
    },

    computed: {
      ...mapGetters('locations', ['selectedLocation']),
      ...mapGetters('menu', ['menu']),
      ...mapGetters('session', ['orderDetails']),

      orderItemsCount() {
        return 1;
      }
    },

    methods: {
      async reorder() {
        try {
          this.reorderingOrderId = this.order.orderId;

          await this.$store.dispatch('orders/reorder', this.order);

          this.$router.push({
            name: 'orderMenu',
            params: {
              merchantId: this.$route.params.merchantId
            }
          });
        }

        catch (error) {
          errorHandlers.generic(error);
        }

        finally {
          this.reorderingOrderId = null;
        }
      },

      editFavoriteOrderClickHandler() {
        this.$openModal('editFavoriteOrder', {
          order: this.order,
          refresh: true
        });
      },

      confirmDeleteFavoriteOrder() {
        this.$openModal('confirmation', {
          title: 'Delete Favorite Order',
          primaryText: `Are you sure you want to delete <b>${this.order.nickname}</b>?`,
          hideSecondaryCta: true,
          onConfirm: () => {
            this.deleteFavoriteOrder(this.order.orderId);
          }
        });
      },

      deleteFavoriteOrder(orderId) {
        this.$store.dispatch('favoriteOrders/deleteFavoriteOrder', orderId);
      }
    }
  };
</script>
